import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { expVal } from '@confluence/feature-experiments';

import FooterCreateButtonsQuery, {
	type FooterCreateButtonsQuery$data,
	type FooterCreateButtonsQuery$variables,
} from './ContentTreeFooter/__generated__/FooterCreateButtonsQuery.graphql';

export function preloadFooterCreateButton(spaceKey: string) {
	if (expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		return Promise.resolve();
	}

	return query<FooterCreateButtonsQuery$data, FooterCreateButtonsQuery$variables>({
		query: FooterCreateButtonsQuery,
		errorPolicy: 'all',
		variables: {
			spaceKey,
		},
	});
}
